import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useInfrastructureBankOnContent } from '../../../../hooks/useInfrastructureBankOnContent';
import './BankOn.css';

const BankOn = () => {
  const { content, isLoading } = useInfrastructureBankOnContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="infrastructure-bank-on">
      <div className="infrastructure-bank-on__inner">
        <Reveal className="infrastructure-bank-on__content">
          <h2 className="infrastructure-bank-on__title">{title}</h2>
          {text ? <p className="infrastructure-bank-on__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="infrastructure-bank-on__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default BankOn;
